angular.module("budget_groups")

    .controller("BudgetGroupsListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'uiGridTreeViewConstants', 'gridService', 'treeService', 'modalService', '$uibModal', '$filter', '$translate', '$state', 'logService',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, uiGridTreeViewConstants, gridService, treeService, modalService, $uibModal, $filter, $translate, $state, logService) {
        
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("BUDGET_GROUPS_WRITE");

        $rootScope.title = $filter('translate')('budget_groups.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('budget_groups.title') }
        ];

        $scope.gridOptions = {
            pdfTitle: $filter('translate')('budget_groups.title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            enableSorting: true,
            showTreeExpandNoChildren: true,
            paginationPageSizes: [15, 30, 45],
            paginationPageSize: 15,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, exporterSuppressExport: true },
              { name: 'name', displayName: $filter('translate')('budget_groups.name'), enableFiltering: true, enableHiding: false },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('budget_groups.edit'), action: 'ui-sref="budget_groups.edit({budget_group_id:row.entity.budget_group_id,id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('budget_groups.delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {               
                return Restangular.all('BudgetGroups').getList(options);
            }
        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("budget_groups.edit", { budget_group_id: rowEntity.budget_group_id, id: rowEntity.id });
        }


        $scope.deleteDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('budget_groups.delete'),
                message: $filter('translate')('budget_groups.delete_message') + " " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('BudgetGroups', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('budget_groups.remove_success'));
                        $scope.gridOptions.data =
                             $scope.gridOptions.data.filter(function (el) { return el.id != $scope.id; });
                    }, function (response) {
                        logService.error("Error with status code", response.status);                        
                    });
                }
            });

        };
        
    }])

;